import { Globe, Check } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { useT } from '../i18n/I18nContext';

const LANGS = [
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export default function LanguageSelector({ variant = 'header' }) {
  const { lang, setLang } = useT();
  const isHeader = variant === 'header';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={
            isHeader
              ? 'flex items-center gap-1 text-white/90 hover:text-white transition-colors p-1'
              : 'flex items-center gap-1 text-slate-600 hover:text-slate-900 transition-colors p-1'
          }
          data-testid="language-selector-button"
          aria-label="Language"
        >
          <Globe className="w-5 h-5" />
          <span className="text-xs font-semibold uppercase">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40" data-testid="language-selector-menu">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`language-option-${l.code}`}
            className="flex items-center justify-between"
          >
            <span className="flex items-center gap-2">
              <span aria-hidden="true">{l.flag}</span>
              <span>{l.label}</span>
            </span>
            {lang === l.code && <Check className="w-4 h-4 text-blue-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
